__turbopack_context__.v({
  "hideScrollbar": "GalleryPhotos-module__NBKPAa__hideScrollbar",
});
